import React from "react";

// Variant -> CSS class on top of the shared `.btc-btn` base (see USaleNode.css).
// 'primary' needs no extra class: `.btc-btn` alone already renders the primary look.
const VARIANT_CLASS = {
    primary: "",
    secondary: "btn-secondary",
    danger: "btn-danger",
    ghost: "btn-ghost",
    warning: "btn-warning",
    purple: "btn-purple",
    info: "btn-info",
};

const Button = ({
    variant = "primary",
    size = "md",
    onClick,
    disabled,
    type = "button",
    children,
    className,
}) => {
    const variantClass = VARIANT_CLASS[variant] ?? "";
    const sizeClass = size === "sm" ? "btn-sm" : "";
    const classes = ["btc-btn", variantClass, sizeClass, className]
        .filter(Boolean)
        .join(" ");

    return (
        <button type={type} className={classes} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
};

export default Button;
